/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__NameInputs */

const en_help_center__payments_n_refunds__name = /** @type {(inputs: Help_Center__Payments_N_Refunds__NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments & Refunds`)
};

/**
* | output |
* | --- |
* | "Payments & Refunds" |
*
* @param {Help_Center__Payments_N_Refunds__NameInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__name = /** @type {((inputs?: Help_Center__Payments_N_Refunds__NameInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__NameInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__name(inputs)
});